import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { twMerge } from "@/utils/twMerge";

interface ChatDndPlaceholderProps {
  className?: string;
}

export const ChatDndPlaceholder = ({ className }: ChatDndPlaceholderProps) => {
  const t = useTranslations();

  return (
    <div
      className={twMerge(
        "flex flex-col items-center gap-2.5 text-document-text tracking-tight text-[17px]",
        className,
      )}
    >
      <div className="flex gap-2">
        <Icon name="Image" />
        <Icon name="Embed" />
        <Icon name="Draft" />
      </div>
      {t("chat.dndPlaceholder")}
    </div>
  );
};
